// extracted by mini-css-extract-plugin
export default {"root":"portfolio_root__eCcrz"};